export default __webpack_public_path__ + "static/media/loan.b72bcbd6.svg";